import React, { useState, useEffect, useRef } from 'react';
import classes from './Chat.module.css';
import { Button, Heading, Text } from 'components/common';
import { IoMdSend } from 'react-icons/io';
import { IoWarningOutline } from 'react-icons/io5';
import { userImgPlaceholder } from 'images';

const Chat = () => {
  const [messages, setMessages] = useState([
    { 
      id: 0,
      type: 'profile',
      sender: 'manager',
      managerName: 'Andrei',
      managerTitle: 'Investment Manager @antrexcapital',
      managerImage: userImgPlaceholder
    },
    // { 
    //   id: 1, 
    //   sender: 'manager', 
    //   text: 'Hello! How can I help you today?', 
    //   timestamp: new Date(),
    //   managerName: 'Andrei',
    //   managerImage: userImgPlaceholder
    // },
  ]);
  const [newMessage, setNewMessage] = useState('');
  const messagesEndRef = useRef(null);

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  useEffect(() => {
    scrollToBottom();
  }, [messages]);

  const handleSendMessage = (e) => {
    e.preventDefault();
    if (newMessage.trim()) {
      setMessages([
        ...messages,
        {
          id: messages.length + 1,
          sender: 'user',
          text: newMessage,
          timestamp: new Date(),
        },
      ]);
      setNewMessage('');
    }
  };

  return (
    <div className={classes.wrapper}>
     
      <div className={classes.chatContainer}>
        <div className={classes.messages}>
          {messages.map((message) => (
            message.type === 'profile' ? (
              <div key={message.id} className={classes.profileMessage}>
                <img 
                  src={message.managerImage} 
                  alt={message.managerName} 
                  className={classes.agentAvatar}
                />
                <div className={classes.agentInfo}>
                  <Text lg bold>{message.managerName}</Text>
                  <Text sm primitive600>{message.managerTitle}</Text>
                </div>
              </div>
            ) : (
              <div
                key={message.id}
                className={`${classes.message} ${
                  message.sender === 'user' ? classes.userMessage : classes.managerMessage
                }`}
              >
                {message.sender === 'manager' && (
                  <img 
                    src={message.managerImage} 
                    alt={message.managerName} 
                    className={classes.avatar}
                  />
                )}
                <div className={classes.messageContent}>
                  {message.sender === 'manager' && (
                    <Text className={classes.managerName}>{message.managerName}</Text>
                  )}
                  <Text className={classes.messageText}>{message.text}</Text>
                  <Text sm primitive600 className={classes.timestamp}>
                    {message.timestamp.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                  </Text>
                </div>
              </div>
            )
          ))}
          <div ref={messagesEndRef} />
        </div>

        <div className={classes.warning}>
          <IoWarningOutline className={classes.warningIcon} />
          <Text sm>Due to a lot of user requests, a response may take up to 12 hours, but it is usually before 1 hour.</Text>
        </div>

        <form onSubmit={handleSendMessage} className={classes.inputContainer}>
          <input
            type="text"
            value={newMessage}
            onChange={(e) => setNewMessage(e.target.value)}
            placeholder="Type your message..."
            className={classes.input}
          />
          <Button type="submit" className={classes.sendButton}>
            <IoMdSend />
          </Button>
        </form>
      </div>
    </div>
  );
};

export default Chat; 